import { IMDSButtonProps, MDSButtonLoadingIndicator, MDSButtonSlotName } from "./button.types";
import { StyledButton, StyledSpinnerOverlay } from "./button.style";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";
import { MdsIcon } from "@/design-system/components/icon";
import { MdsIconKind } from "@/design-system/components/icon";
import classNames from "classnames";
import { forwardRef, Ref } from "react";
import { MDSButtonIcon } from "./button-icon";

export const MDSButton = forwardRef(
  (
    {
      children,
      isLoading,
      loadingIndicator = MDSButtonLoadingIndicator.Overlay,
      ...props
    }: IMDSButtonProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    const { className, isDisabled, isToggled, ...buttonProps } = props;
    const unslottedChildren = getUnslottedChildren(children);
    const leftIcon = getSlot(children, MDSButtonSlotName.LeftIcon);
    const rightIcon = getSlot(children, MDSButtonSlotName.RightIcon);
    const useIconPlacement = isLoading && loadingIndicator === MDSButtonLoadingIndicator.Icon;
    const showOverlay = isLoading && loadingIndicator === MDSButtonLoadingIndicator.Overlay;

    return (
      <StyledButton
        data-mds-name="button"
        {...buttonProps}
        className={classNames("mds-button", className)}
        isDisabled={isLoading || isDisabled}
        isToggled={isToggled}
        ref={ref}
      >
        {useIconPlacement ? (
          <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={MdsIconKind.Spinner} />
        ) : (
          leftIcon
        )}
        {unslottedChildren}
        {rightIcon}

        {showOverlay && (
          <StyledSpinnerOverlay>
            <MdsIcon kind={MdsIconKind.Spinner} />
          </StyledSpinnerOverlay>
        )}
      </StyledButton>
    );
  }
);
